<template>
  <div class="wfh-modal-mask">
    <div class="wfh-modal-wrapper">
      <div class="wfh-modal-content">
        <div class="row">
          <button type="button" @click="closeModal" class="modal-close-btn">
            X
          </button>
        </div>

        <div class="row mb-4">
          <div class="col-6">
            <label class="wfh-label">From</label>
            <v-ctk-datepicker
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="startDate"
                :no-button-now="true"
                :auto-close="true"
                :no-label="true"
                :only-date="true"
            />
          </div>
          <div class="col-6">
            <label class="wfh-label">Till</label>
            <v-ctk-datepicker
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="endDate"
                :no-button-now="true"
                :auto-close="true"
                :no-label="true"
                :only-date="true"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <button type="button" class="btn btn-block wfh-btn-primary-outline" @click="resetSelection">Clear</button>
          </div>
          <div class="col-6">
            <button type="button" class="btn wfh-btn-primary" style="min-height: auto !important;" @click="selectDate">
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: { vSelect },

  props: {
    startDateKey: {
      required: false,
      default: 'wfh_tm_sd',
    },
    endDateKey: {
      required: false,
      default: 'wfh_tm_ed',
    },
  },

  data () {
    return {
      originalStartDate: null,
      originalEndDate: null,
      startDate: null,
      endDate: null,
    };
  },

  computed: {
    actionButtonClass () {
      return {
        'col-12': true,
        'col-md-6': !this.isNewField || !this.isDisabled,
        'col-md-5': this.isNewField || this.isDisabled,
        'mx-auto': this.isNewField || this.isDisabled,
      };
    },
  },

  methods: {
    closeModal () {
      this.resetSelection();
      this.$emit('close');
    },

    selectDate () {
      localStorage.setItem(this.startDateKey, this.startDate);
      localStorage.setItem(this.endDateKey, this.endDate);

      this.$emit('selected', this.startDate, this.endDate);
    },

    setDefaultDates () {
      this.originalEndDate = localStorage.getItem(this.endDateKey);
      this.endDate = localStorage.getItem(this.endDateKey);

      this.originalStartDate = localStorage.getItem(this.startDateKey);
      this.startDate = localStorage.getItem(this.startDateKey);
    },

    resetSelection () {
      this.startDate = JSON.parse(JSON.stringify(this.originalStartDate));
      this.endDate = JSON.parse(JSON.stringify(this.originalEndDate));
    },
  },

  mounted () {
    document.body.style.position = 'fixed';
    document.body.style.top = `-${window.scrollY}px`;

    this.setDefaultDates();
  },

  beforeDestroy () {
    const scrollY = document.body.style.top;

    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  },
};
</script>
